// 适配效果
// if(window.innerWidth >= 1920){
//     let scals = document.documentElement.clientWidth / 1920
//     document.documentElement.style.fontSize = ( scals.toFixed(1) * 16 ) + 'px'
    
// }else{
//     let scals = document.documentElement.clientWidth / 1920
//     if(scals < 1){
//         scals = 1
//     }
//     document.documentElement.style.fontSize = (13 * scals) + 'px'
// }

document.documentElement.style.fontSize = (13 * 1) + 'px'